<script setup lang="ts">
withDefaults(defineProps<{
	isSelected?: boolean;
}>(), {
	isSelected: false,
});
</script>

<template>
	<button
		class="bg-primary-400 rounded-[7px] px-6 py-3 w-full text-left box-border border-2 transition-all ease-in-out duration-200"
		:class="isSelected ? 'border-primary-100' : 'border-transparent'"
		type="button"
		role="checkbox"
		:aria-checked="isSelected"
	>
		<span class="text-xl leading-none">
			<slot />
		</span>
	</button>
</template>
